function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "google_svg__google_svg__clip-path-a",
  d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
}));

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "google_svg__google_svg__clip-path-b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_svg__google_svg__clip-path-a",
  overflow: "visible"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#google_svg__google_svg__clip-path-b)",
  fill: "#FBBC05",
  d: "M0 37V11l17 13z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#google_svg__google_svg__clip-path-b)",
  fill: "#EA4335",
  d: "M0 11l17 13 7-6.1L48 14V0H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#google_svg__google_svg__clip-path-b)",
  fill: "#34A853",
  d: "M0 37l30-23 7.9 1L48 0v48H0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#google_svg__google_svg__clip-path-b)",
  fill: "#4285F4",
  d: "M48 48L17 24l-4-3 35-10z"
});

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 48,
    height: 48
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgGoogle;